<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppBox from '@/components/app/box.vue';
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppConversation from '@/components/app/conversation.vue';
  import AppDateViewer from '@/components/app/dateViewer.vue';
  // -------------------
  import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
  import SharedHelper from '@/Helpers/Shared';
  export default {
    components: {
      AppBox,
      AppTitleHeader,
      AppConversation,
      AppDateViewer,
    },
    mixins: [SharedHelper, HospitalMixin],
    props: {
      missionPhoneId: {
        type: Number,
        default: 0,
      },
      creationDate: {
        type: String,
        default: '',
        required: true,
      },
      phoneCode: {
        type: String,
        default: '-',
        required: false,
      },
      phoneNumber: {
        type: String,
        default: '-',
        required: false,
      },
      diagnosisTitle: {
        type: String,
        default: '-',
        required: false,
      },
      chiefComplaintText: {
        type: String,
        default: '-',
        required: false,
      },
      chiefComplaintNote: {
        type: String,
        default: '-',
        required: false,
      },
      address: {
        type: String,
        default: '-',
        required: false,
      },
      hospital: {
        type: Object,
        default: () => {
          return {
            id: 0,
            title: '-',
            phoneNumber: '-',
          };
        },
        required: false,
      },
    },
    mounted() {
      this.getListOfAllActiveHospitalsFunction();
    },
    data() {
      return {
        hospitalBody: {
          selectedHospital: '',
          changeHospitalNote: '',
          missionPhoneId: this.missionPhoneId,
        },
        changeHospitalModal: false,
      };
    },
    methods: {
      showHospitalModal: function () {
        this.changeHospitalModal = true;
        this.getListOfAllActiveHospitalsFunction();
      },
      setChangeHospital: function () {
        if (!this.hospitalBody.selectedHospital) {
          this.showErrorAlert('بیمارستان را انتخاب نمایید');
          return;
        }
        if (this.hasHospital === true) {
          if (!this.hospitalBody.changeHospitalNote) {
            this.showErrorAlert('توضیحات را وارد نمایید');
            return;
          }
          if (!this.hospitalBody.changeHospitalNote.replace(/\s/g, '').length) {
            this.showErrorAlert('توضیحات را وارد نمایید');
            return;
          }
        } else {
          this.hospitalBody.changeHospitalNote = '';
        }
        this.hospitalBody.missionPhoneId = this.missionPhoneId;
        this.$emit('sendMissionToHospital', this.hospitalBody, this.cancelChangeHospital);
      },
      cancelChangeHospital: function () {
        this.hospitalBody.changeHospitalNote = '';
        this.changeHospitalModal = false;
      },
    },
    computed: {
      missionDate: function () {
        return this.creationDate;
      },
      hasHospital: function () {
        return !!this.hospital?.id;
      },
    },
    watch: {
      hospital: {
        handler(currentVal) {
          if (currentVal?.id) this.hospitalBody.selectedHospital = currentVal?.id;
        },
        immediate: true,
      },
    },
  };
</script>
<template>
  <v-row no-gutters>
    <v-dialog v-model="changeHospitalModal" width="500" persistent style="z-index: 1">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-text</v-icon>
              <span class="modal-title-text mr-2">تغییر بیمارستان</span>
              <v-spacer></v-spacer>
              <v-icon @click="cancleChangeHospital()" class="ml-2">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                :items="allActiveHospitals"
                no-data-text="اطلاعاتی وجود ندارد"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle-outline"
                item-text="title"
                item-value="id"
                label="بیمارستان*"
                v-model="hospitalBody.selectedHospital"
                autocomplete="off"
                prepend-inner-icon="mdi-ambulance mdi-18px"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="hasHospital">
              <v-textarea
                rows="5"
                outlined
                label="توضیحات"
                dense
                type="text"
                clearable
                clear-icon="mdi-close-circle-outline"
                v-model="hospitalBody.changeHospitalNote"
                v-on:keyup.enter="setChangeHospital()"
                class="input-label"
                prepend-inner-icon="mdi-text mdi-18px"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            @click="setChangeHospital()"
            dark
            rounded
            class="normal-letter-spacing px-12"
          >
            ثبت
          </v-btn>
          <v-btn
            rounded
            color="darkColor"
            outlined
            @click="cancelChangeHospital()"
            class="normal-letter-spacing px-10"
          >
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12" class="pa-4">
      <app-title-header title="اطلاعات ماموریت" />
    </v-col>
    <v-col cols="12" class="px-4">
      <app-box outlined max-height="180px">
        <v-row>
          <v-col cols="12" class="d-flex justify-between gap-2">
            <div class="flex flex-col gap-2 justify-between">
              <app-conversation :between="true" question="تاریخ ماموریت">
                <template v-slot:answer>
                  <app-date-viewer :date="creationDate" class="custom-answer" />
                </template>
              </app-conversation>
              <app-conversation
                :between="true"
                question="شماره تماس"
                :answer="phoneNumber"
                custom-answer="text-left"
              />
            </div>
            <div class="seperator"></div>
            <div class="flex flex-col gap-2 justify-between">
              <app-conversation :between="true" question="بیمارستان">
                <template v-slot:answer>
                  <div v-if="hospital?.title" class="flex-gap-1 justify-end">
                    <div class="custom-answer">
                      {{ hospital?.title }}
                    </div>
                    <v-icon color="darkColor" @click="showHospitalModal">
                      mdi-pencil mdi-18px
                    </v-icon>
                  </div>
                </template>
              </app-conversation>
              <app-conversation :between="true" question="کد آمبولانس" :answer="phoneCode" />
            </div>
          </v-col>
          <v-col cols="12" class="flex flex-col gap-2">
            <app-conversation
              :between="true"
              question="تشخیص احتمالی پرستار"
              :answer="diagnosisTitle"
            />
            <app-conversation :between="true" question="شکایت اصلی" :answer="chiefComplaintText" />
            <app-conversation :between="true" question="آدرس" :answer="address" />
            <app-conversation :between="true" question="توضیح شکایت" :answer="chiefComplaintNote" />
          </v-col>
        </v-row>
      </app-box>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
  .custom-answer {
    font-weight: 600;
  }
  .seperator {
    width: 1px;
    height: 100%;
    background-color: #21212133;
  }
</style>
